"use client";

import React, { useEffect, useState } from "react";
import { InfiniteMovingCards } from "../../ui/infinite-moving-cards";

export default function Reviews() {
  return (
    <div className="h-[20rem] rounded-md flex flex-col antialiased items-center justify-center relative overflow-hidden">
      <InfiniteMovingCards
        items={testimonials}
        direction="right"
        speed="slow"
      />
    </div>
  );
}

const testimonials = [
  {
    quote:
      "AssignOwl's AI grading gave me instant feedback on my essay before submission. The detailed rubric breakdown helped me understand exactly where I needed to improve. My final grade improved by two letter grades!",
    name: "Emily Johnson",
    title: "MSc Accounting",
  },
  {
    quote:
      "As a philosophy student, I was skeptical about AI understanding nuanced arguments. But the feedback on my thesis was incredibly detailed, catching logical gaps I missed. It's like having a professor review my work 24/7.",
    name: "David Smith",
    title: "PhD Philosophy Candidate",
  },
  {
    quote: "The instant scoring on my lab reports is a game-changer. I can check my work before submission and fix issues immediately. My professor commented that my recent submissions have been exceptionally well-structured.",
    name: "Sophia Garcia",
    title: "B.S. in Biomedical Science",
  },
  {
    quote:
      "Between work and studies, I needed quick feedback on my assignments. AssignOwl scores my work in seconds with detailed explanations. It's saved me from so many avoidable mistakes and boosted my confidence before submitting.",
    name: "Liam O'Connor",
    title: "International Business Student",
  },
  {
    quote:
      "The technical accuracy of the code review is impressive. It caught edge cases in my algorithms and provided constructive feedback on optimization. My programming assignments have never been better scored.",
    name: "Olivia Chen",
    title: "Masters in Computer Science",
  },
];